import ImageWrapper from "../ImageWrapper";
import { Body, Heading } from "@/client/foundations/Typography";
import classNames from "classnames";
import BuyNowCTA from "./BuyNowCTA";

interface ProductCardProps {
  id?: string | undefined,
  selectedTheme?: string;
  brand?: string;
  title?: string;
  price?: string;
  subTitle?: string;
  image_link?: string;
  link?: string;
  no_of_columns: number;
  animated?: boolean;
  animation?: string;
  btn?: any;
  maxCardWidth?: string;
  businessUnitCode?: string;
  buttonLabel?: string
  openInNewTab?: boolean
}
const ProductCard = ({
  id = "",
  brand,
  title,
  subTitle,
  price,
  buttonLabel = "Buy now",
  image_link,
  businessUnitCode,
  openInNewTab=true,
  ...props
}: ProductCardProps) => {


  return (
    <div
      className="flex flex-col p-2 rounded-16 bg-productCard-bg text-productCard-text"
      style={{ maxWidth: props?.maxCardWidth || "500px" }}
    >
      <ImageWrapper
        priority
        width={500}
        height={500}
        objectFit="cover"
        loader={({ src }) => src}
        style={{ width: "100%", height: "auto", maxHeight: "100%" }}
        alt=""
        className="mb-2 rounded-16"
        src={image_link || ""}
      />
      {brand && (
        <Body
          size="m"
          animated={props?.animated ?? false}
          animation={props?.animation ?? ""}
          className="!text-productCard-brand-s sm:!text-productCard-brand-m md:!text-productCard-brand-l xl:!text-productCard-brand-xl mb-1"
        >
          {brand || ""}
        </Body>
      )}

      {title && (
        <Heading
          size="m"
          className={classNames(
            "!text-productCard-title-s sm:!text-productCard-title-m md:!text-productCard-title-l xl:!text-productCard-title-xl",
            "mb-[4px] truncate"
          )}
          animated={props?.animated ?? false}
          animation={props?.animation ?? ""}
        >
          {title || ""}
        </Heading>
      )}

      {subTitle && (
        <Body
          size="m"
          animated={props?.animated ?? false}
          animation={props?.animation ?? ""}
          className="h-[45px] sm:h-[32px] md:h-[45px] line-clamp-2 !text-productCard-subTitle-s sm:!text-productCard-subTitle-m md:!text-productCard-subTitle-l xl:!text-productCard-subTitle-xl mb-1"
        >
          {subTitle || ""}
        </Body>
      )}

      <div className="flex justify-between items-center mt-2">
        {price && (
          <Heading
            size="m"
            className="!text-productCard-price-s sm:!text-productCard-price-m md:!text-productCard-price-l xl:!text-productCard-price-xl"
            animated={props?.animated ?? false}
            animation={props?.animation ?? ""}
          >
            {price || ""}
          </Heading>
        )}
        <BuyNowCTA
          id={id}
          brand={brand}
          title={title}
          price={price}
          link={props?.link}
          businessUnitCode={businessUnitCode}
          btn={{
            variant: props?.btn?.variant,
            size: props?.btn?.size,
            label: props?.btn?.label || buttonLabel, //props?.btnLabel,
            target: props?.btn?.target || openInNewTab ? "_blank" : "_self"//"_blank"
          }}
        />
      </div>
    </div>
  );
};

export default ProductCard;
